/** Treat missing values and the literal string "null" as empty for CAP API fields. */
export function capDisplayValue(value) {
  if (value === undefined || value === null) return '';
  const trimmed = String(value).trim();
  if (trimmed === '' || trimmed.toLowerCase() === 'null') return '';
  return trimmed;
}

export function capDisplayCell(value) {
  return capDisplayValue(value) || '—';
}
